import { useNumerousReleases } from "@/api";
import NumerousLogo from "@/components/logo/NumerousLogo";
import { Button } from "@/components/ui/button";
import Dialog from "@/components/ui/dialog";
import { Dispatch, SetStateAction } from "react";
import { v1Release } from "../assets/v1Release";
import { Release } from "./Release";

interface Props {
  onOpenChange: Dispatch<SetStateAction<boolean>>;
  prevVersionId: string | undefined;
}

export function ReleaseNotes({ onOpenChange, prevVersionId }: Props) {
  const { data } = useNumerousReleases();

  if (!data) return null;

  let prevVersionPos = prevVersionId
    ? data.numerousReleases.findIndex(({ id }) => id === prevVersionId)
    : data.numerousReleases.length;

  return (
    <Dialog.Root open onOpenChange={onOpenChange}>
      <Dialog.Content className="max-w-screen-lg w-10/12 dark:bg-brand-gray-900 p-0 gap-0 overflow-hidden">
        <div className="flex gap-4 dark:bg-brand-gray-900 bg-white p-6 pb-4">
          <NumerousLogo type="fullLogo" size="sm" />
          Releases
          <Dialog.Close asChild>
            <Button variant="outline" className="ml-auto">
              Dismiss
            </Button>
          </Dialog.Close>
        </div>
        <div className="p-6 pt-0 flex flex-col gap-4 overflow-y-auto max-h-[80vh]">
          {data?.numerousReleases.map((release, i) => (
            <Release
              key={release.id}
              release={release}
              isNewRelease={i < prevVersionPos}
            />
          ))}
          <Release release={v1Release} isNewRelease={!prevVersionId} />
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
}
